export const SET_ITEMS = '@@miscWq/SET_ITEMS'
export const SET_LOADING = '@@miscWq/SET_LOADING'
export const SET_ERROR = '@@miscWq/SET_ERROR'
export const SET_LAST_REQUEST_ID = '@@miscWq/SET_LAST_REQUEST_ID'
export const SET_FILTERS = '@@miscWq/SET_FILTERS'
export const RESET_FILTERS = '@@miscWq/RESET_FILTERS'

export const initialState = {
  items: [],
  template: [],
  loading: false,
  error: null,
  lastRequestId: null,
  filters: {
    search: '',
    status: null,
    submissionStartDate: null,
    submissionEndDate: null,
  },
}

const MiscellaneousMyWorkQueueReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ITEMS:
      return { ...state, items: action.items, template: action.template }
    case SET_LOADING:
      return { ...state, loading: action.loading }
    case SET_ERROR:
      return { ...state, error: action.error }
    case SET_LAST_REQUEST_ID:
      return { ...state, lastRequestId: action.requestId }
    case SET_FILTERS:
      return { ...state, filters: { ...state.filters, ...action.filters } }
    case RESET_FILTERS:
      return { ...state, filters: initialState.filters }
    default:
      return state
  }
}

export default MiscellaneousMyWorkQueueReducer